import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import {PlusOutlined, DeleteOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
@inject('intelligentQueryStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()

  componentDidMount() {
    const {title, record} = this.props
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'word': record?.word,
        'description': record?.description,
        'other_words': record?.other_words?.length > 0 ? record?.other_words?.map(item => ({value: item})) : [''],
      })
    } else {
      this.formRef.current.setFieldsValue({
        'word': '',
        'description': '',
        'other_words': [''],
      })
    }
  }

  handleOk = () => {
    const {intelligentQueryStore, handleCancel, title, record} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      const other_words = fieldsValue?.other_words?.map(item => item.value).filter(Boolean) || []
      let params = {
        "id": title === 'edit' ? record?.id : null,
        "word": fieldsValue?.word,
        "description": fieldsValue?.description,
        "other_words": other_words,
        "specific_ds": false,
      }
      intelligentQueryStore.onTerminologyAddAction(params, title).then(res=> {
        if (res?.data?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }

  render() {
    const { addModalVisible, handleCancel, title, t } = this.props
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`intelligentQuery.editTerminology`) : t(`intelligentQuery.createTerminology`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addTerminology" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item name="word" label={t(`intelligentQuery.terminologyName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`intelligentQuery.terminologyName`)}`,
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="description" label={t(`intelligentQuery.terminologyDesc`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`intelligentQuery.terminologyDesc`)}`,
                }]}>
                  <Input.TextArea maxLength={500} placeholder={t(`general.pleaseEnter`)} rows={4} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row style={{marginBottom: '8px'}}>
                  <Col span={4} style={{fontSize: '16px', lineHeight: '32px'}}>同义词</Col>
                  <Col span={20} style={{textAlign: 'right'}}>
                    <Button type="link" icon={<PlusOutlined />} onClick={() => this.formRef.current.setFieldsValue({
                      other_words: [...(this.formRef.current.getFieldValue('other_words') || []), {value: ''}]
                    })} style={{paddingRight: 0}}>
                      添加
                    </Button>
                  </Col>
                </Row>
                <Form.List name="other_words" initialValue={[]}>
                  {(fields, {add, remove}) => (
                    <>
                      {fields.map((field, index) => (
                        <Row key={field.key} style={{marginBottom: '8px', display: 'flex', alignItems: 'center'}}>
                          <Col flex={1}>
                            <Form.Item
                              {...field}
                              name={[field.name, 'value']}
                              style={{marginBottom: 0}}
                            >
                              <Input placeholder="请输入同义词" />
                            </Form.Item>
                          </Col>
                          <Col span={2} style={{display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                            {fields?.length > 1 && <Button
                              type="text"
                              icon={<DeleteOutlined />}
                              onClick={() => remove(field.name)}
                              style={{color: '#ff4d4f'}}
                            />}
                          </Col>
                        </Row>
                      ))}
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)